import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { NavLink } from "react-router-dom";
import { adminDeleteSpecificCheckpoint } from "@services/checkpoint.service";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBarCheckpoint/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import {
  adminGetCountriesListManagement,
  adminGetListManagementGroupCode,
  adminGetStatesListManagement,
  getSmartFilterCategoryOfLawList,
  getSmartFilterLegislationList,
  getSmartFilterLegislationRuleList,
} from "@services/list-management.service";
import { adminBulkUpdateStatus, adminGetUsers } from "@services/users.service";
import {
  UpdateSelfComplianceTaskIC,
  bulkUpdateSelfComplianceTaskIC,
  downloadSelfComplianceReportsIC,
  getSelfComplianceTaskListIC,
  updateSelfComplianceListStatusIC,
  updateSelfComplianceListUserIC,
} from "@services/internal-compliance.service";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { formatText } from "@_common/format-text";
import AssignTaskFilterForm from "@components/common/AddFilter/AssignTaskFilterForm";
import {
  getChildEntityGroups,
  getEntityGroups,
} from "@services/entity-mapping.service";
import {
  NewDate,
  convertCurrentDate,
  convertCurrentDateWithTime,
  convertDate,
  convertDateAsString,
  todayDate,
} from "@_common/date-helpers";
import DatePicker from "react-datepicker";
import InputField from "@_common/InputRuleFeild";
import DragAndDropFileComponent from "@_common/file-drag-drop";
import { clientAdminFileUpload } from "@services/client-list.service";
import _ from "lodash";
import { tableStatusStyle } from "@_common/colors";
import SelfComplianceUpdatePopup from "@components/common/SelfComplianceDetail/UpdateTaskPopup";
import { downloadSelfComplianceReports } from "@services/import.service";
import FooterWrapper from "@components/common/FooterWrapper";
import MenuRepositorySvgComponent from "../../../../../../src/assets/svg-components/left-menu/menurepo";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import MappedCheckpointMasterNotfound from "@components/Page-Not-Found/mappedc-master-not-found";
import ChangeOwnerModal from "@pages/Repository/popup/changeOwnerModal";
import { getSpecificCategoryLawById } from "@_common/global-apis";
import { countKeysWithValues } from "@_common/text-helpers";

interface ICheckpointActiveProps {}

const RepositoryInternalComplianceFunctionHead: React.FunctionComponent<ICheckpointActiveProps> = (
  props: any
) => {
  let navigate = useNavigate();
  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let request = QueryRequestHelper({ ...params });
    return request;
  };

  const mainQueryRequest = urlParamsFun();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);

  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const [filterOptions] = useState([
    { value: "DRAFT", label: "Draft" },
    { value: "ACTIVE", label: "Active" },
    { value: "ARCHIVED", label: "Archived" },
  ]);
  const [complianceStatusOptions] = useState([
    { value: "ASSIGNED", label: "Assigned" },
    { value: "POSING", label: "Posing" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "DELAYED", label: "Delayed" },
    { value: "DELAYED_REPORTED", label: "Delayed Reported" },
    { value: "RE_OPENED", label: "Re Opened" },
    { value: "EVENT_NOT_OCCURED", label: "Event Not Occured" },
    { value: "AWAITING_APPROVAL", label: "Awaiting Approval" },
    { value: "REPORTED_NON_COMPLIED", label: "Reported Non Complied" },
  ]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    getPEComplianceList();
    getUsersList("", "");
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      getSmartFilterList();
      getHeaderList(paramsObj, 0);
      getExecutorList("", "");
      getEvaluator("", "");
      getFunctionHead("", "");

      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      setFirstDay(from_date);
      setLastDay(to_date);

      getCategoryLawList("", "", "");
      getLegislationList("", "", "");
      getLegislationRuleList("", "", "");
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      getSmartFilterList();
      getExecutorList("", getValue(params, `executor`, ""));
      getEvaluator("", getValue(params, `evaluator`, ""));
      getFunctionHead("", getValue(params, `function_head`, ""));
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      setRequest({
        country_id: getValue(params, `country_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        category_of_law_id: getValue(params, `category_of_law_id`, ""),
        legislation_id: getValue(params, `legislation_id`, ""),
        legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
        executor: getValue(params, `executor`, ""),
        evaluator: getValue(params, `evaluator`, ""),
        function_head: getValue(params, `function_head`, ""),
        compliance_status: getValue(params, `compliance_status`, ""),
      });
      if (
        getValue(params, `country_id`, "") ||
        getValue(params, `level1`, "")
      ) {
        setFilterVisibility(true);
        getStatesList(getValue(params, `country_id`, ""));
      }
      if (
        getValue(params, `state_id`, "") ||
        getValue(params, `category_of_law_id`, "") ||
        getValue(params, `legislation_id`, "")
      ) {
        getCategoryLawList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `category_of_law_id`, "")
        );
        getLegislationList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `legislation_id`, "")
        );
        getLegislationRuleList(
          "",
          getValue(params, `legislation_id`, ""),
          getValue(params, `legislation_rule_id`, "")
        );
      } else {
        getCategoryLawList("", "", "");
        getLegislationList("", "", "");
        getLegislationRuleList("", "", "");
      }

      if (getValue(params, `smart_filter_tags`, "")) {
        getSmartFilterList();
        // getLegislationRuleList(getValue(params, `legislation_id`, ""));
      }
      if (params.from_date && params.to_date) {
        // setDate(new Date(params.date));
        var from_date = new Date(params.from_date);
        var to_date = new Date(params.to_date);
        setFirstDay(from_date);
        setLastDay(to_date);
      }

      let paramObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(params, `level${i}`, "")) {
          paramObj[`level${i}`] = getValue(params, `level${i}`, "");
        }
      }
      setParamsObj(paramObj);
      getHeaderList(paramObj, 0);
    }
  }, [window.location.href, props.permissionAPITriggered]);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [licenseIDs, setLicenseIDs] = useState([]);
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let payload: any = {
      from_date: convertDate(from_date),
      to_date: convertDate(to_date),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      // status: "active",
      sort_by: params.sort_by,
      country_id: parseInt(getValue(params, `country_id`, "")),
      state_id: parseInt(getValue(params, `state_id`, "")),
      category_of_law_id: await getSpecificCategoryLawById(
        getValue(params, `category_of_law_id`, "")
      ),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      event_id: parseInt(getValue(params, `event_id`, "")),
      sub_event_id: parseInt(getValue(params, `sub_event_id`, "")),
      smart_filter_tags: selectedIDs,
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
      request_from: "FUNCTION_HEAD",
      executor: getValue(params, `executor`, ""),
      evaluator: getValue(params, `evaluator`, ""),
      function_head: getValue(params, `function_head`, ""),
      compliance_status: getValue(params, `compliance_status`, ""),
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
          "_"
        )[0];
      }
    }
    let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    try {
      setIsLoading(true);
      let resp = await getSelfComplianceTaskListIC(queryRequest);
      // let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.compliance_tasks`, []).map((item: object) => ({
            ...item,
            task_id: getValue(item, `task_id`, ""),
            category_of_lawName: getValue(item, `category_of_law.text`, ""),
            compliance_typeName: getValue(item, `compliance_type.text`, ""),
            frequencyName: getValue(
              item,
              `self_compliance.checkpoint.frequency.text`,
              ""
            ),
            compliance_activity: getValue(item, `compliance_activity`, ""),
            legislationName: getValue(
              item,
              `self_compliance.checkpoint.legislation.legislation_name`,
              ""
            ),
            reference: getValue(
              item,
              `self_compliance.checkpoint.reference`,
              ""
            ),
            who: getValue(item, `self_compliance.checkpoint.who`, ""),
            when: getValue(item, `self_compliance.checkpoint.when`, ""),
            frequency: getValue(
              item,
              `self_compliance.checkpoint.frequency.text`,
              ""
            ),
            legislation_ruleName: getValue(
              item,
              `self_compliance.checkpoint.legislation_rule.rule_name`,
              ""
            ),
            activation_status: formatText(
              getValue(item, `activation_status`, "")
            ),
            compliance_status_formatted: formatText(
              getValue(item, `compliance_status`, "")
            ),
            work_status_formatted: formatText(
              getValue(item, `work_status`, "")
            ),
            configure: getValue(item, `is_configured`, "")
              ? "Configured"
              : "Not Configured",
            legal_due_date: convertCurrentDate(
              getValue(item, `legal_due_date`, "")
            ),
            created_at: convertCurrentDateWithTime(
              getValue(item, `created_at`, "")
            ),
            activation_status_formatted: formatText(
              getValue(item, `self_compliance.activation_status`, "")
            ),
            executor_date: convertCurrentDate(
              getValue(item, `owner_due_date`, "")
            ),
            procedure: getValue(
              item,
              `self_compliance.checkpoint.procedure`,
              ""
            ),
            impact: getValue(item, `self_compliance.impact.text`, ""),
            countryName: getValue(item, `internal_compliance.ic_checkpoint.country.name`, ""),
            stateName: getValue(item, `internal_compliance.ic_checkpoint.state.name`, ""),
            categoryName: getValue(item, `internal_compliance.ic_checkpoint.category.text`, ""),
            period_name: getValue(item, `internal_compliance.ic_checkpoint.period.text`, ""),
            control_frequency: getValue(item, `internal_compliance.ic_checkpoint.control_frequency.text`, ""),
            process_name: getValue(item, `internal_compliance.ic_checkpoint.process_name`, ""),
            regulation_name: getValue(item, `internal_compliance.ic_checkpoint.regulation`,""),
            risk_name: getValue(item, `internal_compliance.ic_checkpoint.risk`, ""),
            activity_name: getValue(item,`internal_compliance.ic_checkpoint.activity`, ""), 
            overall_risk_rating: getValue(item, `internal_compliance.ic_checkpoint.overall_risk_rating`, ""),
          }))
        );
        let licenseIDs = getValue(resp, `data.checkpoints`, []).filter(
          (item: object) =>
            getValue(item, `compliance_type.text`, "") === "License"
        );
        setLicenseIDs(
          getValue(licenseIDs, `length`, 0) > 0
            ? licenseIDs.map((item: any) => item.id)
            : []
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };
  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };
  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificCheckpoint(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  // const handleChangeSortBy = (value: string) => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	const params = Object.fromEntries(urlSearchParams.entries());
  // 	params.sort_by = value;
  // 	props.history.push({
  // 		pathname: window.location.pathname,
  // 		query: params,
  // 	});
  // };

  // const handleChangeStatus = (value: string) => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	const params = Object.fromEntries(urlSearchParams.entries());
  // 	params.status = value;
  // 	props.history.push({
  // 		pathname: window.location.pathname,
  // 		query: params,
  // 	});
  // };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const rowClick = (obj: object) => {
    if (getValue(obj, `original.internal_compliance.ic_checkpoint.id`, "")) {
      navigate(
        `/repository/internal-mapping/function-head/task-details/${getValue(
          obj,
          `original.id`,
          ""
        )}/${getValue(obj, `original.internal_compliance.ic_checkpoint.id`, "")}?${mainQueryRequest}`
      );
    } else {
      toast.error("Checkpoint not available");
    }
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
      };
    }
    return {};
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Task ID",
        accessor: "task_id",
        width: 140,
        Cell: ({ row }: any) => {
          return (
            <NavLink to={`#`}>{getValue(row, `original.task_id`, "")}</NavLink>
          );
        },
      },{
        Header: "Country",
        accessor: "countryName",
        width: 100,
      },
      {
        Header: "State",
        accessor: "stateName",
        width: 120,
      },
      {
        Header: "Category",
        accessor: "categoryName",
        width: 100,
      },
      {
        Header: "Period",
        accessor: "period_name",
        width: 100,
      },
      {
        Header: "Control Frequency",
        accessor: "control_frequency",
        width: 150,
      },
      {
        Header: "Process Name",
        accessor: "process_name",
        // width: 250,
      },
      {
        Header: "Regulation",
        accessor: "regulation_name",
        width: 250,
      },
      {
        Header: "Risk",
        accessor: "risk_name",
        width:150,
      },
      {
        Header: "Activity",
        accessor: "activity_name",
        width: 250,
      },
      {
        Header: "Overall Risk Rating",
        accessor: "overall_risk_rating",
        width: 150,
      },
      // {
      // 	Header: "Category of Law",
      // 	accessor: "category_of_lawName",
      // 	width: 250,
      // },
      // {
      //   Header: "Legislation",
      //   accessor: "legislationName",
      //   width: 350,
      // },
      // {
      //   Header: "Rule",
      //   accessor: "legislation_ruleName",
      //   width: 350,
      // },
      // {
      //   Header: "Reference",
      //   accessor: "reference",
      //   width: 250,
      // },
      // {
      //   Header: "Who",
      //   accessor: "who",
      //   width: 250,
      // },
      // {
      //   Header: "When",
      //   accessor: "when",
      //   width: 250,
      // },
      // {
      //   Header: "Procedure",
      //   accessor: "procedure",
      //   width: 250,
      // },
      // {
      //   Header: "Impact",
      //   accessor: "impact",
      //   width: 100,
      // },
      // {
      //   Header: "Frequency",
      //   accessor: "frequency",
      //   width: 100,
      // },
      // {
      // 	Header: "Work Status",
      // 	accessor: "work_status_formatted",
      // 	width: 250,
      // },
      {
        Header: "Compliance Status",
        accessor: "compliance_status_formatted",
        width: 250,
      },
      {
        Header: "Legal Due Date",
        accessor: "legal_due_date",
        width: 120,
      },
      {
        Header: "Executor Date",
        accessor: "executor_date",
        width: 150,
      },

      {
        Header: "Created Date",
        accessor: "created_at",
        width: 150,
      },
      // {
      // 	Header: "Action",
      // 	width: 250,
      // 	Cell: ({ row }: any) => {
      // 		return (
      // 			<>
      // 				<Button
      // 					color="primary"
      // 					onClick={() => handleEdit(row.original.id)}
      // 				>
      // 					Edit
      // 				</Button>
      // 				&nbsp;&nbsp;&nbsp;
      // 				<Button
      // 					color="danger"
      // 					onClick={() =>
      // 						handleDeleteFun(row.original.id, row.values.checkpoint_id)
      // 					}
      // 				>
      // 					Delete
      // 				</Button>
      // 			</>
      // 		);
      // 	},
      // },
    ],
    []
  );
  /* -------------------------------------------------------------------------- */
  /*                              Navigation Routes                             */
  /* -------------------------------------------------------------------------- */

  const handleNavigate = (route: string) => {
    let payload: any = {};
    if (route === "release-to-vendor") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "assign-to-PE") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "add-to-tracker") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "assign-task") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/checkpoint/${route}?${queryRequest}`);
  };
  const [permissionLoading, setPermissionLoading] = React.useState(true);
  const handleChangeStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                                  Smart Filters                             */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    country_id: "101",
    state_id: "",
    category_of_law_id: "",
    legislation_id: "",
    legislation_rule_id: "",
    event_id: "",
    sub_event_id: "",
    executor: "",
    evaluator: "",
    function_head: "",
    compliance_status: "",
  });
  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);
  const [smartFilterList, setSmartFilterList] = useState([]);
  const [selectedSmartFilterIds, setSelectedSmartFilterIds] = useState<any>([]);
  const handleChangeSelectMulti = (e: any) => {
    setSelectedSmartFilterIds(e);
  };

  const reset = () => {
    setParamsObj({});
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    setFilterVisibility(false);
    getData();
    reset1();
  };
  const [resetInput, setResetInput] = useState(false);
  const reset1 = () => {
    setRequest({
      ...request,
      // country_id: "",
      state_id: "",
      category_of_law_id: "",
      legislation_id: "",
      legislation_rule_id: "",
      event_id: "",
      sub_event_id: "",
      executor: "",
      evaluator: "",
      function_head: "",
      compliance_status: "",
    });
    setSelectedSmartFilterIds([]);
    setResetInput(true);
    // setFilterVisibility(false);
  };

  const getSmartFilterList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    try {
      let resp = await adminGetListManagementGroupCode("smart-filter");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setSmartFilterList(obj);
        if (getValue(selectedIDs, `length`, 0) > 0) {
          let arr: [] | any = [];
          selectedIDs.map((item: object) => {
            let filtered = obj.filter((ob: any) => ob.id == item);
            if (getValue(filtered, `length`, 0) > 0) {
              arr.push(filtered[0]);
            }
          });
          setSelectedSmartFilterIds(arr);
        }
      } else {
      }
    } catch (error) {}
  };

  const [peComplianceList, setPeComplianceList] = useState([]);
  const getPEComplianceList = async () => {
    try {
      let resp = await adminGetListManagementGroupCode("compliance-type");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setPeComplianceList(obj);
      } else {
      }
    } catch (error) {}
  };

  const getCountriesList = async () => {
    try {
      let resp = await adminGetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };

  const getStatesList = async (countryId: number) => {
    if (countryId) {
      try {
        let resp = await adminGetStatesListManagement(countryId);
        if (resp) {
          setStates(
            getValue(resp, `data.states`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `name`, ""),
              label: getValue(item, `name`, ""),
            }))
          );
        } else {
        }
      } catch (error) {}
    }
  };

  /* ---------------------------  Category Of Law  ----------------------------- */
  const [categoryOfLawList, setCategoryOfLawList] = useState([]);
  const [categoryLawLoading, setCategoryLawLoading] = useState(false);
  const getCategoryLawList = async (
    value: string,
    state_id: string,
    id: string
  ) => {
    setResetInput(false);
    try {
      setResetInput(false);
      setCategoryLawLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        // state_id:state_id,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterCategoryOfLawList(queryRequest);
      if (resp) {
        setCategoryOfLawList(
          getValue(resp, `data.stateCategoryOfLaw`, []).map((item: object) => ({
            // ...item,
            // id: getValue(item, `category_of_law.id`, ""),
            id: getValue(item, `id`, ""),
            value: getValue(item, `category_of_law.text`, ""),
            label: getValue(item, `category_of_law.text`, ""),
          }))
        );
        setCategoryLawLoading(false);
        setValue(request, `category_of_law_id`, "");
      } else {
        setCategoryLawLoading(false);
      }
    } catch (error) {
      setCategoryLawLoading(false);
    }
    if (!value) {
      setValue(request, `category_of_law_id`, "");
    }
  };

  /* ---------------------------  Legislation  ----------------------------- */
  const [legislationList, setLegislationList] = useState([]);
  const [legislationLoading, setLegislationLoading] = useState(false);
  const getLegislationList = async (
    value: string,
    state_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setLegislationLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        // state_id:state_id,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationList(queryRequest);
      if (resp) {
        setLegislationList(
          getValue(resp, `data.legislations`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `legislation_name`, ""),
            label: getValue(item, `legislation_name`, ""),
          }))
        );
        setLegislationLoading(false);
        setValue(request, `legislation_id`, "");
      } else {
        setLegislationLoading(false);
      }
    } catch (error) {
      setLegislationLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_id`, "");
    }
  };

  /* ---------------------------  Legislation Rule  ----------------------------- */
  const [ruleList, setRuleList] = useState([]);
  const [legislationRuleLoading, setLegislationRuleLoading] = useState(false);
  const getLegislationRuleList = async (
    value: string,
    legislation_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setLegislationRuleLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        legislation_id: legislation_id
          ? legislation_id
          : getValue(request, `legislation_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationRuleList(queryRequest);
      if (resp) {
        setRuleList(
          getValue(resp, `data.legislationRules`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `rule_name`, ""),
            label: getValue(item, `rule_name`, ""),
          }))
        );
        setLegislationRuleLoading(false);
        setValue(request, `legislation_rule_id`, "");
      } else {
        setLegislationRuleLoading(false);
      }
    } catch (error) {
      setLegislationRuleLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_rule_id`, "");
    }
  };

  /* ---------------------------  Entity Mapping Filters  ----------------------------- */

  const [headerList, setHeaderList] = useState([]);
  const [headerLoading, setHeaderLoading] = useState(false);
  const [levelObj, setLevelObj] = useState<any>({});
  const [paramsObj, setParamsObj] = useState<any>({});

  const getHeaderList = async (paramsObj: any, index: number) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      if (resp) {
        setHeaderList(getValue(resp, `data.entityGroups`, []));
        var result: any = {};
        for (
          let i = 0;
          i < getValue(resp, `data.entityGroups.length`, 0);
          i++
        ) {
          result[
            `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
          ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
        }
        if (Object.keys(levelObj).length === 0) {
          for (let x in result) {
            let keys = Object.keys(result[x])[0];
            levelObj[keys] = {};
          }
        }
        let list =
          Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
        if (getValue(list, `length`, 0) > 0) {
          getEntityList(
            getValue(paramsObj, `level1`, "").split("_")[1],

            `level${getValue(
              resp,
              `data.entityGroups[${0}].group_level`,
              ""
            )}` === `level1`
              ? ""
              : getValue(paramsObj, `level1`, "").split("_")[0],
            ""
          );
          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.entityGroups`,
              []
            ).filter(
              (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
            );
            return getEntityList(
              getValue(findNextLevelInfo, `[${0}].id`, ""),
              item.split("_")[0],
              ""
            );
          });
        } else {
          getEntityList(
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            null,
            ""
          );
        }
        setHeaderLoading(false);
      } else {
        setHeaderLoading(false);
      }
    } catch (error) {
      setHeaderLoading(false);
    }
  };

  const [childEntityList, setChildEntityList] = useState<any>({});
  const [childEntityLoading, setChildEntityLoading] = useState(false);
  const getEntityList = async (
    id: string,
    entity_parent: any,
    search_text: string
  ) => {
    if (id) {
      let payload = {
        entity_group: id,
        entity_parent: entity_parent,
        limit: 10,
        search_text: search_text,
      };
      let queryRequest = QueryRequestHelper(payload);
      setChildEntityLoading(true);
      try {
        let resp = await getChildEntityGroups(queryRequest);
        if (resp) {
          levelObj[id] = getValue(resp, `data.entityMapping`, []).map(
            (item: any) => ({
              ...item,
              value: getValue(item, `entity_name`, ""),
              label: getValue(item, `entity_name`, ""),
            })
          );
          setLevelObj({ ...levelObj });
          setChildEntityLoading(false);
        } else {
          setChildEntityLoading(false);
        }
      } catch (error) {
        setChildEntityLoading(false);
      }
    } else {
      // toast.error("You have Reached Maximum Levels");
    }
  };

  const handleClickEntity = (
    entity_id: any,
    group_id: any,
    group_level: any,
    headerIndex: number
  ) => {
    //user selected level
    let userLevel = `${entity_id}_${group_id}_${group_level}`;
    let payload = { ...paramsObj };
    let selectedLevels =
      Object.values(payload).length > 0 ? Object.values(payload) : [];
    if (!selectedLevels.includes(userLevel)) {
      // appending child entity list that are presented in URL Params
      var result = Object.entries(childEntityList);
      var myNewArray: any =
        getValue(result, `length`, 0) > 0
          ? result.filter(function (item, index) {
              return index + 1 <= group_level;
            })
          : [];
      let obj: any = {};
      if (getValue(myNewArray, `length`, 0) > 0) {
        myNewArray.map((item: any) => {
          obj[item[0]] = item[1];
        });
      }
      setChildEntityList(obj);

      //deleting params if grater then current level selected by the user
      for (let i = group_level + 1; i < 10; i++) {
        delete paramsObj[`level${i}`];
      }

      // replacing url param if it have same group level / else we can add new one
      let checkIfAlreadyExist =
        Object.keys(payload).length > 0
          ? Object.keys(payload).includes(`level${group_level}`)
          : false;
      if (checkIfAlreadyExist) {
        delete paramsObj[`level${group_level}`];
        let obj = {
          ...paramsObj,
          // checkpoint_id: selectedIDs,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getHeaderList(obj, headerIndex);
        // let queryRequest = QueryRequestHelper(obj);
        // navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        let obj = {
          ...paramsObj,
          // checkpoint_id: selectedIDs,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getHeaderList(obj, headerIndex);
        // let queryRequest = QueryRequestHelper(obj);
        // navigate(`${window.location.pathname}?${queryRequest}`);
      }
    } else {
      // toast.error("Already selected");
    }
  };
  const handleChangeEntity = (
    val: string,
    entity_group: string,
    parent_level: any,
    index: number
  ) => {
    let entityID = getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "")
      ? getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "").split(
          "_"
        )[0]
      : null;

    if (!val) {
      getEntityList(entity_group, entityID, "");
      let length = Object.keys(paramsObj).length;
      for (let i = parent_level; i <= length; i++) {
        delete paramsObj[`level${i}`];
      }
      let obj = {
        ...paramsObj,
      };
      setParamsObj(obj);
    } else {
      getEntityList(entity_group, entityID, val);
    }
  };

  /* -----------------------------  Executor  ------------------------------ */

  const [executorList, setExecutorList] = useState([]);
  const [executorLoading, setExecutorLoading] = useState(false);
  const [selectedExecutor, setSelectedExecutor] = useState<any>("");
  const getExecutorList = async (search: string, id: string) => {
    try {
      setResetInput(false);
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      setExecutorLoading(true);
      let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setExecutorLoading(false);
        setExecutorList(
          getValue(resp, `data.users`, []).map((item: any) => ({
            ...item,
            value:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
            label:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
          }))
        );
      } else {
        setExecutorLoading(false);
      }
    } catch (error) {
      setExecutorLoading(false);
    }
    if (!search) {
      setValue(request, `executor`, "");
    }
  };

  /* --------------------------------  Evaluator  ------------------------------ */
  const [evaluatorList, setEvaluatorList] = useState([]);
  const [EvaluatorLoading, setEvaluatorLoading] = useState(false);
  const [selectedEvaluator, setSelectedEvaluator] = useState<any>("");
  const getEvaluator = async (search: string, id: string) => {
    try {
      setResetInput(false);
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      setEvaluatorLoading(true);
      let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setEvaluatorLoading(false);
        setEvaluatorList(
          getValue(resp, `data.users`, []).map((item: any) => ({
            ...item,
            value:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
            label:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
          }))
        );
      } else {
        setEvaluatorLoading(false);
      }
    } catch (error) {
      setEvaluatorLoading(false);
    }

    if (!search) {
      setValue(request, `evaluator`, "");
    }
  };
  /* -----------------------------  FunctionHead  ------------------------------ */
  const [FunctionHead, setFunctionHead] = useState([]);
  const [FunctionHeadLoading, setFunctionHeadLoading] = useState(false);
  const [selectedFunctionHead, setSelectedFunctionHead] = useState<any>("");
  const getFunctionHead = async (search: string, id: string) => {
    try {
      setResetInput(false);
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      setFunctionHeadLoading(true);
      let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setFunctionHeadLoading(false);
        setFunctionHead(
          getValue(resp, `data.users`, []).map((item: any) => ({
            ...item,
            value:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
            label:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
          }))
        );
      } else {
        setFunctionHeadLoading(false);
      }
    } catch (error) {
      setFunctionHeadLoading(false);
    }
    if (!search) {
      setValue(request, `function_head`, "");
    }
  };

  /* ---------------------------  Onchange Smart filter  ----------------------------- */

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
    }
    if (type === "state_id") {
      if (!getValue(e, `id`, "")) {
        setValue(request, `state_id`, "");
        setRequest({
          ...request,
          // state_id: "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", "", "");
        getLegislationList("", "", "");
        getLegislationRuleList("", "", "");
      } else {
        setRequest({
          ...request,
          state_id: getValue(e, `id`, "") ? e.id : "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", e.id, "");
        getLegislationList("", e.id, "");
        setCategoryOfLawList([]);
        setLegislationList([]);
        setRuleList([]);
      }
    }
    if (type === "category_of_law_id") {
      setRequest({
        ...request,
        category_of_law_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "legislation_id") {
      getLegislationRuleList("", getValue(e, `id`, "") ? e.id : "", "");
      setRequest({
        ...request,
        legislation_id: getValue(e, `id`, "") ? e.id : "",
        legislation_rule_id: "",
      });
    }
    if (type === "legislation_rule_id") {
      setRequest({
        ...request,
        legislation_rule_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "frequency_id") {
      setRequest({
        ...request,
        frequency_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "checkpoint_id") {
      setRequest({
        ...request,
        checkpoint_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "executor") {
      setRequest({
        ...request,
        executor: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "evaluator") {
      setRequest({
        ...request,
        evaluator: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "function_head") {
      setRequest({
        ...request,
        function_head: getValue(e, `id`, "") ? e.id : "",
      });
    }
  };
  const handleChangeSelectByValue = (e: object, name: string) => {
    setRequest({
      ...request,
      [name]: getValue(e, `value`, "") ? getValue(e, `value`, "") : "",
    });
  };
  const handleSubmitSmartFilter = () => {
    let selectedSmartFilterIdsPayload = JSON.parse(
      JSON.stringify(selectedSmartFilterIds)
    );
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level${i}`] = getValue(paramsObj, `level${i}`, "");
      }
    }
    // if (
    // 	getValue(request, `country_id`, "")
    // 	// getValue(request, `state_id`, "")
    // 	// && getValue(request, `category_of_law_id`, "") &&
    // 	// getValue(request, `legislation_id`, "") &&
    // 	// getValue(request, `legislation_rule_id`, "")
    // ) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: params.page_no,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      category_of_law_id: getValue(request, `category_of_law_id`, ""),
      legislation_id: getValue(request, `legislation_id`, ""),
      legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
      event_id: getValue(request, `event_id`, ""),
      sub_event_id: getValue(request, `sub_event_id`, ""),
      executor: getValue(request, `executor`, ""),
      evaluator: getValue(request, `evaluator`, ""),
      function_head: getValue(request, `function_head`, ""),
      compliance_status: getValue(request, `compliance_status`, ""),

      smart_filter_tags:
        selectedSmartFilterIdsPayload.length > 0
          ? selectedSmartFilterIdsPayload.map((item: object) =>
              getValue(item, `id`, "")
            )
          : [],
    };
    let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    navigate(`${window.location.pathname}?${queryRequest}`);
    handleFilter();
    // } else {
    // 	toast.error("All fields are mandatory");
    // }
  };

  let country_ID =
    getValue(countryList, `length`, 0) > 0 &&
    countryList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `country_id`, "")
    );
  let state_ID =
    getValue(states, `length`, 0) > 0 &&
    states.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );
  let cat_ID =
    getValue(categoryOfLawList, `length`, 0) > 0 &&
    categoryOfLawList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `category_of_law_id`, "")
    );
  let leg_ID =
    getValue(legislationList, `length`, 0) > 0 &&
    legislationList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_id`, "")
    );
  let rule_ID =
    getValue(ruleList, `length`, 0) > 0 &&
    ruleList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_rule_id`, "")
    );
  let executor_ID =
    getValue(executorList, `length`, 0) > 0 &&
    executorList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `executor`, "")
    );
  let evaluator_ID =
    getValue(evaluatorList, `length`, 0) > 0 &&
    evaluatorList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `evaluator`, "")
    );
  let function_head_ID =
    getValue(FunctionHead, `length`, 0) > 0 &&
    FunctionHead.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `function_head`, "")
    );
  let compliance_status_ID =
    getValue(complianceStatusOptions, `length`, 0) > 0 &&
    complianceStatusOptions.filter(
      (item: object) =>
        getValue(item, `value`, "") ==
        getValue(request, `compliance_status`, "")
    );
  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await bulkUpdateSelfComplianceTaskIC({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* ---------------------------  Update Modal  ----------------------------- */

  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const [selectedObj, setSelectedObj] = useState({});

  const handleUpdateTask = () => {
    setShowUpdatePopup(!showUpdatePopup);
    let findOne =
      getValue(list, `length`, 0) > 0
        ? list.filter(
            (item) =>
              getValue(item, `id`, "") === getValue(selectedIDs, `[${0}]`, "")
          )
        : [];
    setSelectedObj(getValue(findOne, `[${0}]`, {}));
    if (getValue(findOne, `length`, 0) > 0) {
      setSelfCompliance({
        ...selfCompliance,
        completion_date: getValue(findOne, `[${0}].completion_date`, null)
          ? NewDate(getValue(findOne, `[${0}].completion_date`, null))
          : new Date(),
        compliance_status: getValue(findOne, `[${0}].compliance_status`, null),
        work_status: getValue(findOne, `[${0}].work_status`, null),
        remarks: getValue(findOne, `[${0}].remarks`, null),
        non_compliance_reason: getValue(
          findOne,
          `[${0}].non_compliance_reason`,
          null
        ),
        event_not_occured: getValue(findOne, `[${0}].event_not_occured`, false),
        document_ids: getValue(findOne, `[${0}].documents`, []),
      });
      setUpdateId(getValue(findOne, `[${0}].self_compliance.id`, null));
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [from_date, setFirstDay] = React.useState(new Date());
  const [to_date, setLastDay] = React.useState(new Date());
  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };
  const handleSubmitDate = () => {
    let first = convertDate(from_date);
    let last = convertDate(to_date);
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        from_date: first,
        to_date: last,
      };
      if (payload.from_date && payload.to_date) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Update Popup                               */
  /* -------------------------------------------------------------------------- */

  const [selfCompliance, setSelfCompliance] = useState<any>({
    completion_date: "",
    compliance_status: "",
    work_status: "",
    remarks: "",
    non_compliance_reason: "",
    event_not_occured: false,
    document_ids: [],
  });
  const [updateId, setUpdateId] = useState("");

  const [complianceStatusList] = useState([
    { value: "PENDING", label: "Pending" },
    { value: "WORK_IN_PROGRESS", label: "Work In Progress" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "NOT_APPLICABLE", label: "Not Applicable" },
    { value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
  ]);

  // const handleUploadDocuments = async (e: any) => {
  // 	Array.from(e).forEach(async (item: any) => {
  // 		let formData = new FormData();
  // 		formData.append("file", item);
  // 		try {
  // 			let resp = await clientAdminFileUpload(formData);
  // 			if (resp) {
  // 				getValue(selfCompliance, `document_ids`, "").push(
  // 					getValue(resp, `data`, {})
  // 				);

  // 				setSelfCompliance({ ...selfCompliance });
  // 				e = null;
  // 			} else {
  // 				e = null;
  // 			}
  // 		} catch (error) {
  // 			e = null;
  // 		}
  // 	});
  // };
  const fileTypes = ["PDF", "JPEG", "XLSX", "CSV", "XLSM", "XLX", "JPG", "PNG"];
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const handleSubmitTask = async (status: string) => {
    if (getValue(selfCompliance, `completion_date`, "")) {
      let obj = JSON.parse(JSON.stringify(selfCompliance));
      obj["compliance_status"] = status;
      obj["document_ids"] =
        getValue(selfCompliance, `document_ids.length`, 0) > 0
          ? getValue(
              selfCompliance,
              `document_ids`,
              []
            ).map((item: object) => ({ id: getValue(item, `id`, "") }))
          : [];
      if (
        (getValue(selectedObj, `self_compliance.document_required`, false)
          ? getValue(selfCompliance, `document_ids.length`, 0) > 0
            ? false
            : true
          : false) &&
        !getValue(selfCompliance, `event_not_occured`, false)
      ) {
        toast.error("Documents required");
      } else {
        setSelectedStatus(status);
        try {
          setSubmitLoading(true);
          let resp = await UpdateSelfComplianceTaskIC(selectedIDs[0], obj);
          if (resp) {
            toast.success(getValue(resp, `message`, ""));
            setSubmitLoading(false);
            setShowUpdatePopup(false);
            setSelfCompliance({
              ...selfCompliance,
              completion_date: "",
              compliance_status: "",
              work_status: "",
              remarks: "",
              non_compliance_reason: "",
              event_not_occured: false,
              document_ids: [],
            });
            setUpdateId("");
            setSelectedStatus("");
            getData();
          } else {
            setSubmitLoading(false);
            setSelectedStatus("");
          }
        } catch (error) {
          setSubmitLoading(false);
          setSelectedStatus("");
        }
      }
    } else {
      toast.error("Completion date is mandatory");
    }
  };

  const handleUpdateStatus = async (value: string) => {
    try {
      let payload = {
        ids: selectedIDs,
        activation_status: value,
      };
      let resp = await updateSelfComplianceListStatusIC(payload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      }
    } catch (error) {}
  };

  /* --------------------------------------------------------------------------- */
  /* -----------------------------  Owner Change  ------------------------------ */
  /* --------------------------------------------------------------------------- */
  const [isOpen, setIsOpen] = useState(false);
  const [userList, setUsersList] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [submitUserLoading, setSubmitUserLoading] = useState(false);
  const [request1, setRequest1] = useState({
    type: "",
    id: "",
  });
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const getUsersList = async (search: string, id: string) => {
    try {
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      setUserLoading(true);
      let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setUserLoading(false);
        setUsersList(
          getValue(resp, `data.users`, []).map((item: any) => ({
            ...item,
            value:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
            label:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
          }))
        );
        setRequest1({
          ...request1,
          type: "",
          id: "",
        });
      } else {
        setUserLoading(false);
      }
    } catch (error) {
      setUserLoading(false);
    }
    if (!search) {
      setRequest1({
        ...request1,
        id: "",
      });
    }
  };
  const handleSubmitChangeUser = async () => {
    let IDs = list.filter((item: object) =>
      selectedIDs.includes(getValue(item, `id`, ""))
    );
    let selfComplianceIds =
      getValue(IDs, `length`, 0) > 0
        ? IDs.map((item: object) => getValue(item, `self_compliance.id`, ""))
        : [];
    let uniqueComplianceIds = _.uniq(selfComplianceIds);
    try {
      if (getValue(request1, `type`, "") && getValue(request1, `id`, "")) {
        setSubmitUserLoading(true);
        let resp = await updateSelfComplianceListUserIC({
          ids: selectedIDs,
          [getValue(request1, `type`, "")]: getValue(request1, `id`, ""),
          self_compliance_ids: uniqueComplianceIds,
        });
        if (resp) {
          setSubmitUserLoading(false);
          toast.success(getValue(resp, `message`, ""));
          getData();
          setIsOpen(false);
          setRequest1({
            ...request1,
            type: "",
            id: "",
          });
        } else {
          setSubmitUserLoading(false);
        }
      } else {
        toast.error("All fields are mandatory");
      }
    } catch (error) {
      setSubmitUserLoading(false);
    }
  };
  const handleChangeSelectUser = (e: any, type: string) => {
    if (type === "user") {
      setRequest1({
        ...request1,
        id: getValue(e, `id`, "") ? e.id : "",
      });
    }
  };
  const removeDocument = (id: string) => {
    let filtered =
      getValue(selfCompliance, `document_ids.length`, 0) > 0
        ? getValue(selfCompliance, `document_ids`, []).filter(
            (item: any) => item.id !== id
          )
        : [];
    setSelfCompliance({
      ...selfCompliance,
      document_ids: filtered,
    });
  };

  /* -------------------------------------------------------------------------- */
  /*                               Upload Section                               */
  /* -------------------------------------------------------------------------- */
  const [uploadLoading, setUploadLoading] = useState(false);
  const handleUploadDocuments = async (e: any) => {
    // e.preventDefault();
    Array.from(e).forEach(async (item: any, index: number) => {
      let formData = new FormData();
      formData.append("file", item);
      setUploadLoading(true);
      try {
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          await selfCompliance.document_ids.push(getValue(resp, `data`, {}));
          setSelfCompliance({ ...selfCompliance });
          e = null;
        } else {
          e = null;
        }
      } catch (error) {
        e = null;
      }
      setUploadLoading(false);
    });
  };
  const handleDrop = (e: any) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        setUploadLoading(true);
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          await selfCompliance.document_ids.push(getValue(resp, `data`, {}));
          setSelfCompliance({ ...selfCompliance });
          e.target.value = null;
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
      }
      setUploadLoading(false);
    });
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const disableUpload = () => {};

  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let payload: any = {
      from_date: convertDate(from_date),
      to_date: convertDate(to_date),
      // page_no: params.page_no ? parseInt(params.page_no) : 1,
      // page_size: params.limit ? parseInt(params.limit) : limit,
      // search_text: params.search_text,
      // status: "active",
      sort_by: params.sort_by,
      country_id: parseInt(getValue(params, `country_id`, "")),
      state_id: parseInt(getValue(params, `state_id`, "")),
      category_of_law_id: await getSpecificCategoryLawById(
        getValue(params, `category_of_law_id`, "")
      ),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      event_id: parseInt(getValue(params, `event_id`, "")),
      sub_event_id: parseInt(getValue(params, `sub_event_id`, "")),
      smart_filter_tags: selectedIDs,
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
      executor: getValue(params, `executor`, ""),
      evaluator: getValue(params, `evaluator`, ""),
      function_head: getValue(params, `function_head`, ""),
      report_type: "INTERNALCOMP_FUNCTION_HEAD",
      report_name: (
        convertDateAsString(from_date) +
        " " +
        "to" +
        " " +
        convertDateAsString(to_date)
      ).toString(),
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
          "_"
        )[0];
      }
    }
    // let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    setDownloadLoading(true);
    try {
      let resp = await downloadSelfComplianceReportsIC({
        ...payload,
        ...levelObj,
      });
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/INTERNALCOMP_FUNCTION_HEAD`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };
  const handleNavigateLogs = () => {
    navigate(`/self-compliance-logs/INTERNALCOMP_FUNCTION_HEAD`);
  };
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "repository_internal_mapping_function_head"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              // isMarkInactiveSectionVisible={true}
              handleChangeActiveStatus={handleChangeActiveStatus}
              multi={true}
              text={"MARK INACTIVE"}
              handleRemoveNavItems={handleRemoveNavItems}
              handleNavigate={handleNavigate}
              permissions={props.permissions}
              licenseIDs={licenseIDs}
              // assignTask
              masterNav={"false"}
              showUpdatePopup={handleUpdateTask}
              handleUpdateStatus={handleUpdateStatus}
              // assignedTaskActive={true}
              hideConfigure={true}
              filterOptions={filterOptions}
              isUpdateTaskVisible={
                getValue(selectedIDs, `length`, 0) === 1 ? true : false
              }
            />
          )}
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
            <h4 className="dashbaord-wrapper__header-title">Function Head</h4>
            <div className="d-flex align-items-center">
              <h6
                className="mx-3 header_text__blue cursor-pointer"
                onClick={() =>
                  navigate(
                    `/repository/internal-mapping/function-head/my-tasks?${mainQueryRequest}`
                  )
                }
              >
                Mapped Tasks
              </h6>
              <div className="filter-form-wrappper__container d-flex">
                <div className="no-bordered-input-calendar mr-2">
                  <DatePicker
                    selectsRange={false}
                    selected={from_date ? new Date(from_date) : null}
                    className="react-date-picker__inputGroup__input"
                    onChange={(date: any) => {
                      if (date && to_date && new Date(date) > new Date(to_date)) {
                        toast.error("From Date cannot be greater than To Date");
                      } else {
                        handleDate([date, to_date]);
                      }
                    }}
                    dateFormat="d MMM yyyy"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="From Date"
                    maxDate={to_date ? new Date(to_date) : undefined}
                  />
                </div>
                <div className="no-bordered-input-calendar mr-2">
                  <DatePicker
                    selectsRange={false}
                    selected={to_date ? new Date(to_date) : null}
                    className="react-date-picker__inputGroup__input"
                    onChange={(date: any) => {
                      if (from_date && date && new Date(from_date) > new Date(date)) {
                        toast.error("To Date cannot be less than From Date");
                      } else {
                        handleDate([from_date, date]);
                      }
                    }}
                    dateFormat="d MMM yyyy"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="To Date"
                    minDate={from_date ? new Date(from_date) : undefined}
                  />
                </div>
                <button
                  className="dashboard-wrapper__apply-btn ml-2"
                  onClick={handleSubmitDate}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuRepositorySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Internal Mapping
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Function Head
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                licenseStyleCalendar={true}
                // Mapped Task FH (Function Head)
                // internalmappedTasksFH={true}
                // date range
                dateRange={true}
                from_date={from_date}
                to_date={to_date}
                handleDate={handleDate}
                // handleCancelDate={handleCancelDate}
                handleSubmitDate={handleSubmitDate}
                // datePickerRef={datePickerRef}
                //alltime
                allTime={false}
                // handleCheckAlltime={handleCheckAlltime}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //smartFilter
                smartFilter={true}
                handleFilter={handleFilter}
                //change owner
                changeOwner={false}
                isOpen={isOpen}
                handleModal={
                  getValue(selectedIDs, `length`, 0) > 0
                    ? handleModal
                    : () => toast.error("Please select task")
                }
                // download section
                downloadSelfComplianceReport={true}
                handleDownloadSelfComplianceReport={
                  handleDownloadSelfComplianceReport
                }
                downloadLoading={downloadLoading}
                //logs section
                viewDownloadedSelfComplianceReports={true}
                handleNavigateLogs={handleNavigateLogs}
                //Line Seperator of button
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
              />
            </div>
          </div>

          <div className={`main-page-layout-wrapper`} id={getValue(selectedIDs, `length`, 0) > 0
					? "blueNavigationVisible"
					: ""}>
            <div className="admin-wrapper position-relative">
              {/* <div className="admin-wrapper position-relative">
                <SearchHeader
                  route={"/support/details"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  isBulkUploadVisible={false}
                  smartFilter={true}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  add={"false"}
                  isFilterVisible={isFilterVisible}
                  filterCompliance
                  peComplianceList={peComplianceList}
                  handleChangeStatus={handleChangeStatus}
                  //change owner
                  // changeOwner
                  isOpen={isOpen}
                  handleModal={
                    getValue(selectedIDs, `length`, 0) > 0
                      ? handleModal
                      : () => toast.error("Please select task")
                  }
                  //self-compliance download section
                  downloadSelfComplianceReport={true}
                  viewDownloadedSelfComplianceReports={true}
                  handleDownloadSelfComplianceReport={
                    handleDownloadSelfComplianceReport
                  }
                  downloadLoading={downloadLoading}
                  handleNavigateLogs={handleNavigateLogs}
                  //----> Compliance Status
                  compliance_status_ID={compliance_status_ID}
                  complianceStatusOptions={complianceStatusOptions}
                  handleChangeSelectByValue={handleChangeSelectByValue}
                  filterComplianceStatus
                  filterIsOpen={filterIsOpen}
                  handleFilter={() => {
                    setFilterIsOpen(!filterIsOpen);
                  }}
                />
              </div> */}
              {/* {isFilterVisible && ( */}
              <AssignTaskFilterForm
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                countryList={countryList}
                states={states}
                handleChangeSelect={handleChangeSelect}
                additionalFilter={true}
                country_ID={country_ID}
                state_ID={state_ID}
                reset={reset}
                handleSubmitSmartFilter={handleSubmitSmartFilter}
                smartFilterList={smartFilterList}
                handleChangeSelectMulti={handleChangeSelectMulti}
                selectedSmartFilterIds={selectedSmartFilterIds}
                events={true}
                request={request}
                //dynamic filter ( Custom Input Select Dropdown)
                //----> category of law
                categoryOfLawList={categoryOfLawList}
                getCategoryLawList={getCategoryLawList}
                categoryLawLoading={categoryLawLoading}
                cat_ID={cat_ID}
                //----> legislation
                legislationList={legislationList}
                getLegislationList={getLegislationList}
                legislationLoading={legislationLoading}
                leg_ID={leg_ID}
                //----> legislation rule
                ruleList={ruleList}
                getLegislationRuleList={getLegislationRuleList}
                rule_ID={rule_ID}
                legislationRuleLoading={legislationRuleLoading}
                resetInput={resetInput}
                //-----> Entity Mapping Filter
                headerList={headerList}
                headerLoading={headerLoading}
                levelObj={levelObj}
                childEntityLoading={childEntityLoading}
                handleClickEntity={handleClickEntity}
                urlParams={paramsObj}
                handleChangeEntity={handleChangeEntity}
                //----> Executor
                executorList={executorList}
                executor_ID={executor_ID}
                executorLoading={executorLoading}
                getExecutorList={getExecutorList}
                //----> Evaluator
                evaluator_ID={evaluator_ID}
                evaluatorList={evaluatorList}
                EvaluatorLoading={EvaluatorLoading}
                getEvaluator={getEvaluator}
                //----> Function Head
                function_head_ID={function_head_ID}
                FunctionHead={FunctionHead}
                FunctionHeadLoading={FunctionHeadLoading}
                getFunctionHead={getFunctionHead}
                //----> Compliance Status
                compliance_status_ID={compliance_status_ID}
                complianceStatusOptions={complianceStatusOptions}
                handleChangeSelectByValue={handleChangeSelectByValue}
                filterIsOpen={filterIsOpen}
                handleFilter={handleFilter}
                internal
                moduleName={"Internal Mapping"}
								subModuleName={"Master"}
                // compliance_status_filter
              />
              {/* )} */}
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list.length > 0 ? (
                <ScrollableDataTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  getTrProps={getTrProps}
                />
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <MappedCheckpointMasterNotfound />
                    </>
                  ) : (
                    <MappedCheckpointMasterNotfound />
                  )}
                </>
              )}
            </div>
            <FooterWrapper
              list={list}
              totalCount={totalCount}
              limit={limit}
              page_no={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          </div>

          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />
        </>
      )}
      {/* complete task popup */}
      <SelfComplianceUpdatePopup
        showUpdatePopup={showUpdatePopup}
        setShowUpdatePopup={setShowUpdatePopup}
        selfCompliance={selfCompliance}
        setSelfCompliance={setSelfCompliance}
        handleUploadDocuments={handleUploadDocuments}
        handleSubmitTask={handleSubmitTask}
        submitLoading={submitLoading}
        complianceStatusList={complianceStatusList}
        permissions={getValue(props, `permissions`, [])}
        selectedStatus={selectedStatus}
        selectedObj={selectedObj}
        removeDocument={removeDocument}
        handleDrop={handleDrop}
        uploadLoading={uploadLoading}
        handleDragOver={handleDragOver}
        disableUpload={disableUpload}
      />
      <ChangeOwnerModal
        isOpen={isOpen}
        userLoading={userLoading}
        submitUserLoading={submitUserLoading}
        userList={userList}
        request={request1}
        setRequest={setRequest1}
        handleModal={handleModal}
        handleSubmitChangeUser={handleSubmitChangeUser}
        handleChangeSelect={handleChangeSelectUser}
        getUsersList={getUsersList}
      />
    </DashboardLayout>
  );
};
export default RepositoryInternalComplianceFunctionHead;
